import { render, staticRenderFns } from "./SenkronPlanListesi.vue?vue&type=template&id=9aa87c44"
import script from "./SenkronPlanListesi.vue?vue&type=script&lang=ts"
export * from "./SenkronPlanListesi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports